import React from "react";

const FaqContent = () => (
    <>
        <h1>よくある質問</h1>

        <p>当クリニックの治療について - 治療後のよくある質問</p>
        <p>当クリニックにおける肥満症治療は公的医療保険が適用されない自由診療です。</p>

        <h2>・通常必要とされる治療内容</h2>
        <p>当クリニックの医師によるオンライン診療のうえ、患者様の状態に応じてGLP-1受動体作動薬の処方および生活習慣に関する指導を行います。</p>

        <h2>・標準的な費用</h2>
        <p>診察料はかかりません。当クリニックの医師がお薬を処方した場合、お薬代がかかります。（プランにより異なります）。</p>

        <h2>・治療期間および回数</h2>
        <p>GLP-1受容体作動薬による体重減少は通常3～6ヶ月かけて徐々に現れます。治療期間および回数は患者様の状態により異なります。</p>

        <h2>・お問い合わせ先</h2>
        <p>当クリニックでの診療に関するご相談・お問い合わせは下記までご連絡ください。</p>
        <p>
            みのかも西クリニック<br />
            住所：〒505-0046 岐阜県美濃加茂市西町５丁目337-1
        </p>
        <p>
            ウェブサイト：<a href="https://mnnc.jp/" target="_blank" rel="noopener noreferrer">https://mnnc.jp/</a><br />
            電話番号：0574-28-5310
        </p>

        <h2>・処方薬について</h2>
        <p>当クリニックでは、医師の診断に基づき、GLP-1受動作動体薬を処方することがあります。</p>

        <h2>1）当クリニックの肥満症治療で処方する薬について</h2>

        <h3>・用法、容量</h3>
        <p>通常、成人は、主成分として0.25mgから投与を開始し、週1回皮下注射します。その後は4週間の間隔で、週1回0.5mg、1.0mg、1.7mgおよび2.4mgの順に増量し、以降は2.4mgを週1回皮下注射します。本剤は1本中に主成分0.25mgを含有します。他に1本中に主成分0.5mg、1.0mg、1.7mgおよび2.4mgを含有する製剤もあります。必ず当クリニックの医師が指示した使用方法に従ってください。</p>

        <h3>・副作用</h3>

        <h3>吐き気（最も一般的）</h3>
        <p>なぜそれが起こるのか：GLP-1受動体作動薬は胃の内容物の排出を遅らせるため、食べ物が胃の中に長く留まります。</p>
        <p>管理のヒント：</p>
        <p>・少量の食事をより頻繁に摂りましょう。</p>
        <p>・脂っこい食べ物、辛い食べ物、甘い食べ物は避けてください。</p>
        <p>・水分補給をしてください（水を少しずつゆっくり飲んでください）。</p>
        <p>・ジンジャーティー、ペパーミントティー、またはプレーンクラッカーが役立つこともあります。</p>
        <p>・症状がひどい場合は、当クリニックの医師が吐き気止めの薬を勧めることがあります。</p>

        <h3>嘔吐</h3>
        <p>管理のヒント：</p>
        <p>・味の薄い食べ物（バナナ、米、アップルソース、トースト）を食べましょう。</p>
        <p>・食後すぐに横になるのは避けてください。</p>
        <p>・トリガー（特定の食品、分量）を追跡します。</p>
        <p>・症状が続く場合は脱水症状の危険があるため、当クリニックの医師に連絡してください。</p>

        <h3>下痢</h3>
        <p>管理のヒント：</p>
        <p>・水分を十分に摂ってください（必要であれば経口補水塩を摂取してください）。</p>
        <p>・カフェイン、脂肪分の多い食べ物、人工甘味料を避けてください（下痢を悪化させる可能性があります）。</p>
        <p>・炎症が起こっている間は、繊維質の少ない、味の薄い食事を心がけてください。</p>

        <h3>便秘</h3>
        <p>管理のヒント：</p>
        <p>・繊維質の摂取量を徐々に増やしてください（野菜、オート麦、チアシード）。</p>
        <p>・十分な水を飲んでください。</p>
        <p>・軽い運動（歩くことは腸の運動を助けます）。</p>
        <p>・市販の便秘薬が役立つ場合がありますので、まずは当クリニックの医師に相談してください。</p>

        <h3>腹痛 / 膨満感 / 消化不良</h3>
        <p>管理のヒント：</p>
        <p>・ゆっくりよく噛んで食べましょう。</p>
        <p>・炭酸飲料は避けてください。</p>
        <p>・少量で軽い食事は胃の圧力を軽減します。</p>

        <h3>頭痛 / 疲労</h3>
        <p>管理のヒント：</p>
        <p>・水分補給をしてください。</p>
        <p>・十分な睡眠を確保してください。</p>
        <p>・バランスの取れた食事（低血糖は疲労を悪化させる可能性があります）。</p>

        <h3>あまり一般的ではないが重篤な副作用（すぐに当クリニックの医師に連絡してください）</h3>
        <p>・激しい腹痛（膵炎の可能性あり）</p>
        <p>・胆嚢の問題（右の背部の痛み、目や皮膚の黄色化）</p>
        <p>・重度のアレルギー反応（発疹、息切れ、呼吸困難）</p>
        <p>・脱水症状を伴う持続的な嘔吐/下痢</p>

        <h2>2）薬の服用をやめたらどうなりますか？</h2>
        <p>肥満症治療による減量効果は通常、数ヶ月かけて徐々に現れます。そのため、食事療法と適度な運動を取り入れながら継続することで、より高い効果が得られるだけでなく、継続的な体重管理にもつながります。</p>

        <h2>3）当クリニックの肥満症治療にはどのようなサポートが含まれていますか？</h2>
        <p>当クリニックの提携医師は、臨床経験豊富な医師です。いつでもオンライン診療を予約し、医師にご相談いただける体制を整えています。</p>

        <h2>4）当クリニックの肥満治療中は厳しい食事制限や激しい運動は必要ですか？</h2>
        <p>当クリニックの肥満症治療による減量効果は通常、数ヶ月かけて徐々に現れます。薬の効果により食欲が軽減され、自然で健康的な生活習慣を取り入れることが可能になるため、厳しい食事制限や激しい運動は必要ありません。</p>

        <h2>配送について</h2>

        <h3>どこに配送しますか？</h3>
        <p>当クリニックが処方するお薬は、日本国内のみの配送となります。配送パートナーがお客様のご自宅まで直接配送いたします。</p>
        <p>
            <a href="mailto:sjlifeapp@shopjapan.co.jp">sjlifeapp@shopjapan.co.jp</a>
        </p>

        <h3>クリニックから届いたお薬の数量が不足している</h3>
        <p>ご不便をおかけして申し訳ございません。ご注文の商品が不足している場合は、みのかも西クリニック（0574-28-5310）にご連絡ください。</p>
    </>
);

export default FaqContent;